import { mapGetters, mapActions } from 'vuex'

const systemModuleName = 'systemmodule'

export default {
  data() {
    return {
      savingStatus: null,
      showSavingStatus: false,
      toastNotificationEnabled: false
    }
  },
  computed: {
    ...mapGetters(systemModuleName, {
      baseSnapshot: 'baseSnapshot',
      currentSnapshot: 'currentSnapshot',
      snapshotDiff: 'snapshotDiff',
      snapshots: 'snapshots',
      hasError: 'hasError',
      saving: 'saving',
      returnRoute: 'returnRoute'
    }),
    ...mapGetters(['debounceDelay'])
  },
  watch: {
    hasError(val) {
      if (val) {
        this.$notification.error('', 'Save Failed')
      }
    },
    saving(val) {
      if (!this.toastNotificationEnabled) {
        this.showSavingStatus = true
      }
      this.savingStatus = val ? 'Saving ...' : (!this.hasError ? 'Saved' : null)
      if (!val || this.hasError) {
        setTimeout(() => {
          this.showSavingStatus = false
        }, 4000)
      }
    }
  },
  methods: {
    ...mapActions(systemModuleName, [
      'clearSnapshots',
      'saveSnapshot',
      'saveInitialSnapshots',
      'setSavingStatus',
      'setErrorStatus'
    ]),

    openToastNotification() {
      if (!this.hasError) {
        this.$notification.success('', 'Information has been successfully saved')
      }
    }
  }
}
